export function getSummaryMenuItemState({
  isConfigured = false,
  hasSummaryAgent = false,
  canManage = false,
  isGenerating = false
} = {}) {
  if (!isConfigured || !hasSummaryAgent || !canManage) {
    return null;
  }

  return {
    action: "generate",
    disabled: Boolean(isGenerating),
    active: Boolean(isGenerating),
    messageId: isGenerating ? "toolbar.ai-summary.generating" : "toolbar.ai-summary.generate",
    defaultMessage: isGenerating ? "Generating Summary" : "Generate Summary"
  };
}
